import * as yup from 'yup';

const preProcessingSchema = yup.object().shape({
  input_coffee_received_kg: yup
    .number()
    .transform(value => (value === '' ? undefined : value))
    .typeError('Input coffee received must be a number')
    .test('max-2-decimals', 'Use at most two decimals', value => value === undefined || Number.isInteger(value * 100))
    .required('Input coffee received is required')
    .min(0, 'Value cannot be negative'),

  winnower_waste_kg: yup
    .number()
    .transform(value => (value === '' ? undefined : value))
    .typeError('Winnower waste must be a number')
    .test('max-2-decimals', 'Use at most two decimals', value => value === undefined || Number.isInteger(value * 100))
    .required('Winnower waste is required')
    .min(0, 'Value cannot be negative'),

  siphon_rejects_kg: yup
    .number()
    .transform(value => (value === '' ? undefined : value))
    .typeError('Siphon rejects must be a number')
    .test('max-2-decimals', 'Use at most two decimals', value => value === undefined || Number.isInteger(value * 100))
    .required('Siphon rejects is required')
    .min(0, 'Value cannot be negative'),

  unripe_coffees_kg: yup
    .number()
    .transform(value => (value === '' ? undefined : value))
    .typeError('Unripe coffees must be a number')
    .test('max-2-decimals', 'Use at most two decimals', value => value === undefined || Number.isInteger(value * 100))
    .required('Unripe coffees is required')
    .min(0, 'Value cannot be negative'),

  ripe_coffee_for_processing_kg: yup
    .number()
    .transform(value => (value === '' ? undefined : value))
    .typeError('Ripe coffee for processing must be a number')
    .test('max-2-decimals', 'Use at most two decimals', value => value === undefined || Number.isInteger(value * 100))
    .required('Ripe coffee for processing is required')
    .min(0, 'Value cannot be negative'),

  completion_of_pre_processing_at: yup
    .date()
    .typeError('Completion date is required')
    .required('Completion of pre-processing date is required'),
});

export default preProcessingSchema;

const optionalNumber = msg =>
  yup
    .number()
    .transform((value, originalValue) => {
      // RHF with valueAsNumber: true will send NaN for empty inputs
      if (
        originalValue === '' ||
        originalValue === null ||
        typeof originalValue === 'undefined' ||
        Number.isNaN(value)
      ) {
        return null;
      }
      return value;
    })
    .nullable()
    .typeError(msg);

export const preProcessingPartialSchema = yup
  .object()
  .shape({
    input_coffee_received_kg: optionalNumber('Input coffee received must be a number'),

    winnower_waste_kg: optionalNumber('Winnower waste must be a number'),

    siphon_rejects_kg: optionalNumber('Siphon rejects must be a number'),

    unripe_coffees_kg: optionalNumber('Unripe coffees must be a number'),

    ripe_coffee_for_processing_kg: optionalNumber('Ripe coffee for processing must be a number'),

    completion_of_pre_processing_at: yup
      .date()
      .transform((value, originalValue) => {
        if (originalValue === '' || originalValue === null || typeof originalValue === 'undefined') {
          return null;
        }
        return value;
      })
      .nullable()
      .typeError('Completion of pre-processing date is invalid'),
  })
  .test('at-least-one', 'At least one field must be filled to save', values => {
    if (!values) return false;

    return Object.values(values).some(v => v !== null && v !== undefined && v !== '');
  });

// export const preProcessingPartialSchema = yup
//   .object()
//   .shape({
//     input_coffee_received_kg: yup.number().typeError('Input coffee received must be a number').nullable(),

//     winnower_waste_kg: yup.number().typeError('Winnower waste must be a number').nullable(),

//     siphon_rejects_kg: yup.number().typeError('Siphon rejects must be a number').nullable(),

//     unripe_coffees_kg: yup.number().typeError('Unripe coffees must be a number').nullable(),

//     ripe_coffee_for_processing_kg: yup.number().typeError('Ripe coffee for processing must be a number').nullable(),

//     completion_of_pre_processing_at: yup.date().typeError('Completion of pre-processing date is invalid').nullable(),
//   })
//   .test('at-least-one', 'At least one field must be filled to save', values => {
//     if (!values) return false;

//     return Object.values(values).some(v => v !== null && v !== undefined && v !== '');
//   });
